import { profile } from "console";
import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const promoteAdPage = {
    mobile: {
         mainWrapper: {
            display: "flex",
            flexDirection: "column" as "column",
        },
        leftWrapper: {
            position: "sticky",
            top: 0,
            zIndex: "5"
        },
        profileWrapper: {
            display: "none"
        },
        rightWrapper: {},
        backButton: {
            container: {
                display: "flex",
                alignItems: "center",
                margin: "5.79vw 4.83vw"
            },
            button: {
                paddingTop: "0.7vw",
                width: "6.76vw",
                height: "6.76vw",
                backgroundColor: Color.LightAsh,
                borderRadius: "50%"
            },
            icon: {
                fill: Color.DeepBlack,
                width: "50%"
            },
            text: {
                display: "inline",
                marginLeft: "2.65vw",
                fontSize: "3.86vw",                
                color: Color.LightBlack
            }
        },
        title: {
            fontWeight: "bold" as "bold",
            color: Color.DeepBlack,
            fontSize: "6.03vw"
        },
        jobCardWrapper: {
            margin: "5.79vw 4.83vw 12.79vw",
            padding: "2vw",
            borderRadius: "2.41vw",
            border: "2px solid" + Color.LoaderBackground,
            card: {
                paddingBottom: "1vw",
                marginTop: "1vw",
                detailWrapper: {
                    width: "100%"
                }
            }
        },
        activePromotionsWrapper: {
            borderRadius: "2.41vw",
            margin: "0 4.83vw 0",
            padding: "2vw",
            border: "2px solid" + Color.LoaderBackground,
            title: {
                margin: "1vw 2.33vw 0 3vw",
                fontWeight: "bold" as "bold",
                color: Color.DeepBlack,
                fontSize: "3.86vw"
            },
            bumpUpWrapper: {
                display: "flex"
            },
            bumpUp: {
                display: "flex",
                alignItems: "center" as "center",
                justifyContent: "center",
                width: "12.91vw",
                height: "12.91vw",
                borderRadius: "50%",
                margin: "3vw 0 0 2vw",
                backgroundColor: Color.LightRed,
                flexShrink: "0"
            },
            bumpUpIcon: {
                width: "50%"
            },
            remainingBumpUp: {
                fontFamily: Font.Poppins,
                margin: "2vw 0 0 4vw",
                alignSelf: "center",
                color: Color.Black
            },
            urgentWrapper: {
                display: "flex",
                marginTop: "3vw"
            },
            urgent: {
                marginLeft: "2vw"
            },
            urgentTag: {
                width: "12.07vw",
                height: "4.83vw",
                marginTop: "1.20vw",
                textAlign: "center",
                lineHeight: "4.83vw",
                borderRadius: "6.03vw",
                background: Color.Red,
                fontSize: "2.17vw",
                color: Color.White
            },
            expireDateWrapper: {
                fontFamily: Font.Poppins,
                flexDirection: "column" as "column"  
            },
            urgentBanner: {
                marginLeft: "4vw"
            },
            expireDate: {
                fontFamily: Font.Poppins,
                marginLeft: "4vw",
                display: "flex",
                flexDirection: "row",
                date: {
                    marginLeft: "2vw"
                }  
            }
        },
        promoteAdContainer: {
            margin: "3vw 4.83vw 0"
        },
        bumpUpContainer: {
            borderRadius: "2.41vw",
            padding: "2vw 2vw 4vw 2vw",
            border: "2px solid" + Color.LoaderBackground
        },
        bumpUpWrapper: {
            display: "flex",
            checkBoxWrapper: {
                margin: "1vw 0 0 3vw"
            },
            checkBox: {
                checkbox: {
                    marginTop: "4vw"
                }
            },
            bumpUp: {
                display: "flex",
                alignItems: "center" as "center",
                justifyContent: "center",
                width: "12.91vw",
                height: "12.91vw",
                borderRadius: "50%",
                margin: "3vw 0 0 2vw",
                backgroundColor: Color.LightRed,
                flexShrink: "0"
            },
            bumpUpIcon: {
                width: "50%"
            },
            titleWrapper: {
                margin: "3vw 2.33vw 0 3vw"
            },
            title: {
                fontWeight: "bold" as "bold",
                color: Color.DeepBlack,
                fontSize: "3.86vw"
            },
            description: {
                fontFamily: Font.Poppins,
                color: Color.Black,
                fontSize: "3.623vw",
                marginTop: "1vw"
            }
        },
        inputWrapper: {
            marginTop: "5vw",
            options: {
                display: "flex",
                marginTop: "3vw",
                alignItems: "center"
            },
            radioInput: {
                margin: "auto 2.41vw auto 15.2vw",
                width: "3.83vw",
                height: "3.83vw",
                boxShadow: "0 0 0 2px " + Color.Gainsboro,
                border: "solid 3px " + Color.White
            },
            daysCount: {
                fontFamily: Font.Poppins,
                marginLeft: "4vw",
                color: Color.Black,
                fontSize: "3.623vw",
                width: "17vw"
            }, 
            price: {
                marginLeft: "4vw",
                color: Color.Blue,
                fontSize: "3.623vw"
            }
        },
        urgentContainer: {
            borderRadius: "2.41vw",
            padding: "2vw 2vw 4vw 2vw",
            margin: "3vw 0 0",
            border: "2px solid" + Color.LoaderBackground
        },
        urgentWrapper: {
            display: "flex",
            checkBoxWrapper: {
                margin: "1vw 0 0 3vw"
            },
            checkBox: {
                checkbox: {
                    marginTop: "4vw"
                }
            },
            urgent: {
                margin: "4vw 0 0 2vw"
            },
            urgentTag: {
                width: "12.07vw",
                height: "4.83vw",
                marginTop: "1.20vw",
                textAlign: "center",
                lineHeight: "4.83vw",
                borderRadius: "6.03vw",
                background: Color.Red,
                fontSize: "2.17vw",
                color: Color.White
            },
            titleWrapper: {
                margin: "3vw 2.33vw 0 3vw"
            },
            title: {
                fontWeight: "bold" as "bold",
                color: Color.DeepBlack,
                fontSize: "3.86vw"
            },
            description: {
                fontFamily: Font.Poppins,
                color: Color.Black,
                fontSize: "3.623vw",
                marginTop: "1vw"
            }
        },
        checkout: {
            margin: "10vw 4.83vw 0",
            borderRadius: "2.41vw",
            border: "2px solid" + Color.LoaderBackground,
            priceSection: {
                marginTop: "5vw"
            },
            promotionType: {
                display: "flex",
                color: Color.SharpAsh,
                fontSize: "3.623vw",
                margin: "2vw 5vw 0",
                height: "6vw",
                borderBottom: "1px solid" + Color.LoaderBackground,
                type: {
                    width: "58vw"
                },
                price: {
                    marginLeft: "auto"
                },
                bold: {
                    fontWeight: "bold" as "bold"
                }
            },
            promoWrapper: {
                height: "21.10vw",
                borderRadius: "2.41vw",
                border: "0.24vw solid " + Color.Gainsboro,
                padding: "4.83vw",
                margin: "4.83vw 5vw 0"
            },
            promoCode: {
                display: "flex",
                flexDirection: "column" as "column"       
            },
            subTitle: {
                fontSize: '4.34vw',
                color: Color.DeepBlack,
                fontWeight: "bold",
                marginTop: "2vw"
            },
            inputWrapper: {
                display: 'flex',
                flexDirection: "row",
                height: "16vw",
                alignItems: "center"
            },
            inputCode: {
                height: "12.07vw",
                margin: "unset",
                borderRadius: "2.41vw"
            },
            promoInvalid: {
                height: "24.80vw",
                border: "0.24vw solid " + Color.Red,
                backgroundColor: Color.Linen
            },
            promoInvalidMessage: {
                fontSize: "3.38vw",
                color: Color.Red
            },
            button: {
                color: Color.Blue,
                borderRadius: '1.2vw',
                fontSize: '4.83vw',
                border: "2px solid" + Color.Blue,
                height: "12.08vw",
                width: '22.71vw',
                marginLeft: "2.17vw",
                fontWeight: "bold",
                applied: {
                    width: '23vw',
                    color: Color.DeepAsh,
                    border: "0.48px solid" + Color.DeepAsh
                }
            },
            checkoutButton: {
                width: "80%",
                height: "10.58vw",
                border: "none",
                color: Color.White,
                background: Color.Green,
                fontWeight: "bold" as "bold",
                fontSize: "4.35vw",
                borderRadius: "2.41vw",
                margin: "3.2vw 0 0 9vw"
            },
            iconGride: {
                display: "flex",
                justifyContent: "center",
                margin: "3.57vh 0"
            },
            paymentIcon: {
                maxWidth: "17.21vw",
                maxHeight: "5.83vw",
                margin: "0 1.93vw 0 0",
                WebkitFilter: "grayscale(1)", 
                filter: "grayscale(1)"
            },
            note: {
                color: Color.Green,
                marginLeft: "6vw",
                fontSize: "3.86vw"
            }
        },
        inputContainer: {
            marginTop: "2.23vh",
            color: Color.DeepAsh
        },
        textInput: {
            height: "12.08vw",
            fontSize: "3.86vw",
            fontFamily: Font.Poppins,
            width: "94%",
            margin: "1.67vh 2.5vw 0 2.5vw"
        }
    },
    desktop: {
        mainWrapper: {            
            flexDirection: "row" as "row",
            padding: "1.56vw",
            hidePaddingTop: {
                paddingTop: "0"
            }
        },        
        leftWrapper: {},
        rightWrapper: {
            width: "100%",
            paddingLeft: "2.32vw"
        },
        topMenuWrapper: {
            display: "flex",
            alignItems: "center" as "center",
            justifyContent: "space-between" as "space-between"
        },
        profileWrapper: {
            display: "visible"
        },
        backButton: {   
            container: {
                margin: "0"
            },         
            button: {
                paddingTop: "0.3vw",
                backgroundColor: Color.Ash, 
                width: "2.60vw",
                height: "2.60vw"
            },
            text: {
                marginLeft: "1.3vw",
                fontSize: " 0.93vw",
                fontWeight: 'bold'
            }          
        },
        title: {
            margin: "0 0 0 4.56vw",
            fontSize: "2.6vw"
        },
        jobCardWrapper: {
            margin: "3.08vw 0 0 4.56vw",
            padding: "0.5vw",
            borderRadius: "0.52vw",
            card: {
                padding: "0.3vw 0 0",
                marginTop: "unset",
                detailWrapper: {
                    width: "52.71vw"
                }
            }
        },
        activePromotionsWrapper: {
            borderRadius: "0.52vw",
            margin: "2vw 0 0 8.83vw",
            padding: "0.5vw 0.5vw 0.9vw",
            width: "28vw",
            isActivePromotions: {
                width: "59.2vw"
            },
            title: {
                margin: "0.5vw 0 0 1vw",
                fontSize: "1.04vw"
            },
            activePromotions: {
                display: "flex"
            },
            bumpUpWrapper: {
                width: "24vw",
                marginRight: "4vw"
            },
            bumpUp: {
                width: "2.91vw",
                height: "2.91vw",
                margin: "1vw 0 0 2vw"
            },
            remainingBumpUp: {
                margin: "1vw 0 0 1.5vw",
                fontSize: "1.04vw"
            },
            urgentWrapper: {
                marginTop: "1vw",
                alignItems: "center"
            },
            urgent: {
                marginLeft: "unset"
            },
            urgentTag: {
                width: "6.22vw",
                height: "1.19vw",
                marginLeft: "1.46vw",
                lineHeight: "1.19vw",
                fontSize: "0.72vw",
                marginTop: "0",
                borderRadius: "1.30vw"
            },
            expireDate: {
                marginLeft: "1.5vw",
                fontSize: "1.04vw"
            }
        },
        promoteAdContainer: {
            display: "flex",
            margin: "2vw 0 0 8.83vw"
        },
        bumpUpContainer: {
            borderRadius: "0.52vw",
            padding: "0.5vw 0.5vw 1vw",
            height: "5.3vw",
            width: "28vw",
            selected: {
                height: "auto"
            }
        },
        bumpUpWrapper: {
            checkBox: {
                checkbox: {
                    marginTop: "unset",
                    borderRadius: "3px"
                }
            },
            checkBoxWrapper: {
                margin: "2vw 0 0 1vw"
            },
            bumpUp: {
                width: "2.91vw",
                height: "2.91vw",
                margin: "1vw 0 0 1vw"
            },
            titleWrapper: {
                margin: "1vw 0 0 1vw",
                width: "18vw"
            },
            title: {
                fontSize: "1.04vw"
            },
            description: {
                fontSize: "0.93vw",
                marginTop: "0.3vw"
            }
        },
        inputWrapper: {
            marginTop: "1vw",
            options: {
                fontFamily: Font.Poppins,
                marginTop: "0.5vw"
            },
            radioInput: {
                margin: "0 0.52vw 0vw 4.14vw",
                border: "solid 3px "+ Color.White,
                width: "0.8vw",
                height: "0.8vw"
            },
            daysCount: {
                marginLeft: "2vw",
                fontSize: "0.93vw",
                width: "5vw"
            }, 
            price: {
                marginLeft: "2vw",
                fontSize: "0.93vw"
            }
        },
        urgentContainer: {
            borderRadius: "0.52vw",
            margin: "0 2vw",
            padding: "0.5vw 0.5vw 1vw",
            height: "5.3vw",
            width: "28vw",
            selected: {
                height: "auto"
            }
        },
        urgentWrapper: {
            checkBox: {
                checkbox: {
                    marginTop: "unset",
                    borderRadius: "3px"
                }
            },
            checkBoxWrapper: {
                margin: "2vw 0 0 1vw"
            },
            urgent: {
                margin: "2vw 0 0"
            },
            urgentTag: {
                width: "6.22vw",
                height: "1.19vw",
                marginLeft: "0.46vw",
                lineHeight: "1.19vw",
                fontSize: "0.72vw",
                marginTop: "0",
                borderRadius: "1.30vw"
            },
            titleWrapper: {
                margin: "1vw 0 0 1vw",
                width: "18vw"
            },
            title: {
                fontSize: "1.04vw"
            },
            description: {
                fontSize: "0.93vw",
                marginTop: "0.3vw"
            }
        },
        checkout: {
            width: "33vw",
            margin: "3vw auto 0",
            borderRadius: "0.52vw",
            priceSection: {
                marginTop: "1vw"
            },
            promotionType: {
                fontSize: "0.94vw",
                margin: "0 1vw 0",
                height: "2vw",
                alignItems: "center",
                type: {
                    width: "25vw"
                }
            },
            promoWrapper: {
                height: "unset",
                width: "auto",
                border: "1px solid " + Color.Gainsboro,
                borderRadius: "0.52vw",
                padding: "1vw 1vw 1vw 1vw",
                alignItems: "center" as "center",
                margin: "1vw 1vw 0"
            },
            promoCode: {
                flexDirection: "row" as "row"          
            },
            subTitle: {
                fontSize: '1.04vw',
                marginLeft: "1vw",
                width: "7vw",
                marginTop: 0
            },
            promoTitle: {
                width: "6.6vw",
                marginLeft: "unset",
                height: "2.86vw"
            },
            inputWrapper: {
                display: 'flex',
                flexDirection: "row",
                alignItems: "center",
                height: "3vw"
            },
            inputCode: {
                width: '11vw',
                borderRadius: '0.52vw',
                backgroundColor: Color.Ash,
                border: "1vw",
                marginLeft: "1.5vw",
                height: "2.5vw"
            },
            promoInvalid: {
                height: "auto",
                border: "0.05vw solid " + Color.Red
            },
            promoInvalidMessage: {
                fontSize: "0.94vw",
                justifySelf: "center"
            },
            button: {
                borderRadius: '0.52vw',
                fontSize: '1.04vw',
                height: "2.6vw",
                width: '8.07vw',
                marginLeft: "1vw",
                border: "3px solid" + Color.Blue,
                applied: {
                    width: 'unset',
                    border: "0.15vw solid " + Color.DeepAsh,
                    margin: "auto 0 auto 0.85vw"
                }
            },
            checkoutButton: {
                display: "block",
                height: "2.60vw",
                fontSize: "1.04vw",
                borderRadius: "0.52vw",
                justifySelf: "center",
                margin: "1.15vw 0 0"
            },
            iconGride: {
                margin: "1.66vw 0 0 0"
            },
            paymentIcon: {
                maxWidth: "5.10vw",
                maxHeight: "1.51vw",
                margin: "0 0.83vw 0 0"
            },
            note: {
                fontSize: "0.83vw",
                marginLeft: "5.66vw"
            }
        },
        inputContainer: {
            marginTop: "1.30vw",
            width: "100%"
        },
        textInput: {
            height: "3.65vw",
            fontSize: "0.93vw",
            paddingLeft: "1.56vw",
            margin: "1.85vh 1vw 0 1vw"
        }
    }
}